// @ts-nocheck
import React from 'react';

/**
 * FilterBar — grid-laid bar that hosts filter controls. Children are usually
 * <FormGroup>+<Select>/<Input> pairs. Use the optional `chips` slot below the
 * grid for active-filter chips + a reset button.
 *
 * `columns` adjusts the desktop grid (default 6, scales down on mobile).
 */
const FilterBar = ({ columns = 6, chips, className = '', children }) => (
  <div className={`mov-filterbar mb-5 ${className}`}>
    <div
      className="grid gap-3 items-end"
      style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
    >
      {children}
    </div>
    {chips && (
      <div className="flex items-center gap-3 flex-wrap mt-3 pt-3 border-t border-dashed border-mov-line">
        {chips}
      </div>
    )}
  </div>
);

/**
 * SegmentedControl — pill-bg segmented toggle. Drives off `value` + `onChange`.
 */
export const SegmentedControl = ({ value, onChange, items = [], className = '' }) => (
  <div className={`mov-segmented inline-flex ${className}`}>
    {items.map((it) => (
      <button
        key={it.value}
        type="button"
        onClick={() => onChange && onChange(it.value)}
        className={`mov-segmented-item ${it.value === value ? 'is-on' : ''}`}
      >
        {it.label}
      </button>
    ))}
  </div>
);

export default FilterBar;
